import React from "react";
import './ref.css'
const ref = () => {

    return(

        <>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <br></br> <br></br>
            <strong>EdXAR REFUND POLICY</strong>
            <br></br>
            <br></br>
Dear Sir/Madam,
<br></br>
Thank you for choosing EdXAR!
<br></br>
<br></br>
At VREON TECH INDIA Pvt. Ltd. (hereinafter “<strong>VREON</strong>”/ “<strong>we</strong>”/ “<strong>our</strong>”/ “<strong>us</strong>”), we value the trust of our customers (“Customer(s)”/ “you”/ “your” / “Subscriber(s)”) and wish to inform you that you have purchased one of the VREON’s product/services as set out in Annexure I (hereinafter referred as “Limited Offer Product(s)”), under a special limited period offer wherein the refund terms mentioned hereunder will apply to your purchase[1] of the relevant <strong>Limited Offer Product(s)</strong>.
<br></br>
<br></br>
Your access to or the usage of the Limited Offer Product(s) shall be governed by the relevant Terms of Use and Privacy Policies of the relevant Limited Offer Product(s) available on the relevant mobile application/website. If you wish to cancel your subscription and/or return the Limited Offer Product(s), you shall be required to submit your cancellation request by writing to sales@vreontech.com.
<br></br>
<br></br>
<strong>Refund Terms for the Limited Offer Product(s):</strong>
<br></br>
<br></br>
1. If you choose to cancel or return the Limited Offer Product(s);
<br></br>
a) within 7 days after the Delivery date/Activation Date/Orientation date ( refer to annexure for date criterion) you shall be eligible for a partial refund. No refund will be provided on the Device/Headgear fee(if applicable), & study material fee as available in the invoice.

<br></br>
b) post 7 days after the Delivery date/Activation Date/Orientation date( refer to annexure ), no refunds shall be claimed or will be entertained.

<br></br>

<br></br>
<img className="tablea" src="table a.png"></img>

<br></br>

2. For any Limited Offer Product(s) purchased by you, you shall not be eligible for any refunds, whatsoever in the following events:
<br></br>
a) If the request for cancellations/return is submitted after 7 days after the Delivery date/Activation Date/Orientation date (refer to annexure).
<br></br>
b) If your access/subscription to the Limited Offer Product(s) is canceled on account of discovery of credible proof regarding any breach of Limited Offer Product(s)’s Terms of Use. The decision of VREON shall be final and binding in this regard.
<br></br>
<br></br>
3. If due to a force majeure event (such as acts of God, government restrictions or other events beyond our control), we have to discontinue the Limited Offer Product(s) that you have already availed; then we are under no obligation to refund the fee for such portion service already availed by you. We are also not liable to provide any additional service in lieu of the service so discontinued
<br></br>
<br></br>
4. Any other refund policy, mentioned anywhere on our website or any other place, does not hold true for the Limited Offer Product(s). Refunds for all other product(s)/service(s) offered by VREON (which are not specified in Annexures) shall be governed through their respective refund policies/terms of use.
<br></br>
<br></br>
5. Mode of Refund: All applicable refunds shall be processed through online transfer in Indian Rupees only, to the source account from where the payment was originally made; a) within a reasonable period of 28 days from the date a written confirmation from our end is provided to you approving the cancellation). In no event, will the applicable refund amount be greater than the amount paid for your purchase. In the event you have availed credit/financing facility while purchasing the Limited Offer Product(s) from us, your refunds shall be processed accordingly with your lender/financing partner.
<br></br>
<br></br>
6. If your payment instrument/account through which original payment was made, is not active or does not support refunds, you shall be required to provide other bank account details belonging to you for processing the relevant refund. We shall not be responsible and/ or accountable for crediting refund money to the wrong account due to incorrect details furnished by you. You shall be required to furnish a declaration for transfer of refund to another bank account in the format and manner as may be required by us.
<br></br>
<br></br>
7. In case you have not received the refund within the above mentioned 14 days period, then write to us at sales@vreontech.com.
<br></br>
<br></br>
8. On account of cancellation of the service(s) procured by you under the Limited Offer Product(s), the services to be provided by us from the date of cancellation, up to exhaustion or expiry of such service(s), shall be considered as services not performed. Accordingly, for return/ cancellation of product(s)/ service(s), we will issue a GST credit note to you, which otherwise may not be issued if the withdrawal and issuance are beyond the timelines allowed under applicable law. In case the cancellation request submission date is after the prescribed timeline, we may issue a commercial credit note, on your request. You may be required to furnish a declaration for the same, in the format and manner as may be required by us.
<br></br>
<br></br>
9. We reserve the right to modify/ replace this Policy at any time, as deemed fit by us, without any prior notice to you.
<br></br>
<br></br>
10. You confirm and acknowledge that you have read and understood the terms set out in this document and accept the same.
<br></br>
<br></br>
11. Further, you undertake not to dispute the refund terms provided under this document by VREON TECH India Pvt. Ltd. or raise any claims beyond the scope provided under this document.
<br></br>
<br></br>
{/* Yours sincerely,
<br></br>
VREON Tech India Pvt. Ltd.
<br></br>
Date:
<br></br>
Name of Employee:
<br></br>
ID:
<br></br>
Accepted and Acknowledged by,
<br></br>
Customer’s Signature
<br></br>
Name:
<br></br>
Mobile Number:
<br></br>
Date:
<br></br> */}

<img className="tableb" src="table b.png"></img>

<br></br>

<strong className="anne">ANNEXURE I</strong>
<br></br>

<img className="tablec" src="table c.png"></img>


</div>
            </div>
            </div>

            </>

);


};

export default ref;